import { getEffectiveSelectionRange } from "../selection-tracker";
import { getNumber } from "./utils";

export async function readDocumentBodyCore(
  ctx: Word.RequestContext
): Promise<{ text: string }> {
  const body = ctx.document.body;
  body.load("text");
  await ctx.sync();
  return { text: body.text ?? "" };
}

export async function readParagraphsCore(
  ctx: Word.RequestContext,
  args: Record<string, unknown> = {}
): Promise<{
  paragraphs: Array<{ index: number; text: string }>;
  total: number;
  truncated: boolean;
}> {
  const start = getNumber(args, "startIndex", false) ?? 0;
  const endArg = getNumber(args, "endIndex", false);
  const paragraphs = ctx.document.body.paragraphs;
  paragraphs.load("items/text");
  await ctx.sync();

  const total = paragraphs.items.length;
  const end = endArg ?? total;
  const safeStart = Math.max(0, Math.min(start, total));
  const safeEnd = Math.max(safeStart, Math.min(end, total));
  const slice = paragraphs.items.slice(safeStart, safeEnd);
  const HARD_CAP = 500;
  const truncated = slice.length > HARD_CAP;
  const out = (truncated ? slice.slice(0, HARD_CAP) : slice).map((p, i) => ({
    index: safeStart + i,
    text: p.text ?? "",
  }));
  return { paragraphs: out, total, truncated };
}

export async function readSelectionCore(ctx: Word.RequestContext): Promise<{
  text: string;
  isEmpty: boolean;
  characterCount: number;
  source: "live" | "bookmark" | "none";
}> {
  const effective = await getEffectiveSelectionRange(ctx);
  if (!effective) {
    return { text: "", isEmpty: true, characterCount: 0, source: "none" };
  }
  effective.range.load("text");
  await ctx.sync();
  const text = effective.range.text ?? "";
  return {
    text,
    isEmpty: text.length === 0,
    characterCount: text.length,
    source: effective.source,
  };
}
